<div class="review-container">
  <div class="review-container__detail">
    <div class="review-container__detail--title">
      {{ content.title }}
    </div>
    <div class="review-container__detail__selections">
      <div
        class="review-container__detail__selections__wrap"
        [class.divider]="!last"
        *ngFor="let selection of content.selections; let last = last"
      >
        <div class="review-container__detail__selections__wrap--title">
          {{ selection.title }}
        </div>
        <div class="review-container__detail__selections__wrap--subtitle">
          {{ selection.subtitle }}
        </div>
      </div>
    </div>

    <div class="review-container__detail__actions">
      <button
        auraButton
        [buttonColor]="action.id === 'cancel' ? 'secondary' : 'primary'"
        [buttonOutlineColor]="action.id === 'cancel' ? 'secondary' : 'primary'"
        class="review-container__detail__actions--button"
        *ngFor="let action of content.actions"
        (click)="onAction(action.id)"
      >
        {{ action.label }}
      </button>
    </div>
  </div>
</div>
